import {Button, ButtonGroup, closeDialog} from 'platform/components';
import {Box, Heading, Icon, Text, VStack} from 'platform/foundation';
import {useDateTimeFormatter} from 'platform/locale';

import {Trans} from 'react-i18next';

import i18n from '@dms/i18n';
import {myProfileRoutes} from '@dms/routes';

import {parseDate} from 'shared/web';

import {GRACE_PERIOD_DIALOG_ID} from './constants/GRACE_PERIOD_DIALOG_ID';

export interface GracePeriodNotificationProps {
  activateUntil: string;
}

export function GracePeriodNotification(props: GracePeriodNotificationProps) {
  const formatDateTime = useDateTimeFormatter();

  const formattedDateTime = formatDateTime('dateTimeShort', parseDate(props.activateUntil));

  return (
    <Box padding={10}>
      <VStack spacing={10} align="center">
        <Icon value="hardware/shield" size={20} isNotFilled />

        <VStack align="center" spacing={2}>
          <Heading size={2} align="center">
            {i18n.t('page.myProfile.labels.multiFactorAuth')}
          </Heading>

          <Text size="small" align="center" color="tertiary">
            <Trans
              i18nKey="page.myProfile.labels.multiFactorAuthDescription"
              components={{bold: <Text alternative inline size="small" />}}
              values={{dateTime: formattedDateTime}}
            />
          </Text>
        </VStack>

        <ButtonGroup align="center">
          <Button
            variant="primary"
            title={i18n.t('page.myProfile.actions.setupMFA')}
            onClick={() => closeDialog(GRACE_PERIOD_DIALOG_ID)}
            to={myProfileRoutes.multiFactorAuthentication}
          />

          <Button
            variant="secondary"
            title={i18n.t('general.actions.remindMeLater')}
            onClick={() => closeDialog(GRACE_PERIOD_DIALOG_ID)}
          />
        </ButtonGroup>
      </VStack>
    </Box>
  );
}
